import { Box, Grid } from '@mui/material'
import { useState, useEffect } from "react"
import useLayoutContext from 'src/hooks/useAuthLayout'

export default function Index() {
    const { drawerOpen } = useLayoutContext()
    const [valor, setValor] = useState({
        nombres: '',
        apellidos: '',
        tipo_documento: '',
        documento: '',
        id: '',
        dates: '',
        fecha: ''
    })


    useEffect(() => {
        console.log(drawerOpen.item.object)
        let object = drawerOpen.item.object
        setValor({
            nombres: object.datos.nombres,
            apellidos: object.datos.ape_paterno + ' ' + object.datos.ape_materno,
            documento: object.datos.numero_documento,
            tipo_documento: object.datos.nombre_tipo_documento,
            id: '',
            fecha: object.createdAt.split('T')[0].split('-').reverse().join('-'),
            dates: ((parseInt(object.createdAt.split('T')[1].split('.')[0].split(':')[0]) - 5) < 0 ? (parseInt(object.createdAt.split('T')[1].split('.')[0].split(':')[0]) - 5) * -1 : (parseInt(object.createdAt.split('T')[1].split('.')[0].split(':')[0]) - 5)) + ':' + object.createdAt.split('T')[1].split('.')[0].split(':')[1]
        })
    }, [drawerOpen])

    // Define the string
    let decodedStringBtoA = `<!DOCTYPE html>
    <html lang="en">
    
    <head>
        <meta charset="UTF-8">
        <meta http-equiv="X-UA-Compatible" content="IE=edge">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Pruebas</title>
    </head>
    
    <body style="margin: 20px 1rem 20px 1rem; font-family: Arial, Helvetica, sans-serif; width: 100vh">
        <div style=" border: 1px solid #efefef; border-radius: 10px;">
            <h2 style="text-align: center;">POLITICA DE PRIVACIDAD</h2>
            <div>
                La Clinica Vesalio en concordancia con lo
                establecido en la Ley N 29733 'Ley de Proteccion
                de Datos Personales', su reglamento y/o otras
                normas reglamentarias, complementarias,
                modificatorias, sustitutorias y demas disposiciones
                aplicables (en adelante la Ley); garantiza la
                seguridad por la proteccion y privacidad en el
                tratamiento de los datos personales facilitados por
                sus Usuarios, Proveedores y Trabajadores. Para lo
                cual se establecen las siguientes politicas de
                privacidad de la clinica.
            </div>
            <div style="margin-top: 20px;">
                <b>PRIMERA POLITICA:</b>
                <p style="margin-top: 5px;">Toda informacion proporcionada a la Clinica
                    Vesalio a traves de documentos o por su sitio
                    web, sera objeto de tratamiento con la finalidad
                    de ejecutar cualquier relacion juridica, comercial,
                    contractual, o de cualquier indole, que
                    mantenga y/o mantendra con el Usuario, asi
                    como para fines estadisticos y/o analiticos, y/o de
                    comportamiento del cliente y/o para que evaluen
                    la calidad del servicio brindado.</p>
            </div>
            <div style="margin-top: 20px;">
                <b>SEGUNDA POLITICA:</b>
                <p style="margin-top: 5px;">Toda transferencia de datos personales a
                    terceros se realizara siempre que el Titular haya
                    prestado su consentimiento para ello, el mismo
                    que debe ser libre, previo, inequivoco e
                    informado, especificando la finalidad de dicha
                    transferencia de acuerdo a lo senalado por la Ley.</p>
            </div>
            <div style="margin-top: 20px;">
                <b>TERCERA POLITICA:</b>
                <p style="margin-top: 5px;">Esta Politica de Privacidad es de aplicacion a todos
                    los bancos de datos personales cuyo titular sea la
                    Clinica Vesalio, en el que los datos personales
                    proporcionados se conservan mientras no se
                    solicite su cancelacion por el titular del dato en
                    cumplimiento con la ley y normativa aplicable al
                    sector salud.</p>
            </div>
            <div style="margin-top: 20px;">
                <b>CUARTA POLITICA:</b>
                <p style="margin-top: 5px;">Clinica Vesalio adopta las medidas de seguridad
                    necesarias para garantizar la proteccion de la
                    informacion del Usuario a fin de evitar su alteracion,
                    perdida, tratamiento y/o acceso no autorizado,
                    tomando en consideracion la naturaleza de la
                    informacion y los riesgos a los que se encuentran
                    expuestos. Para proteger los datos personales del
                    Usuario, cumplimos estrictamente con lo
                    establecido en la Ley, Reglamento, Directiva y
                    Normas complementarias.</p>
            </div>
            <div style="margin-top: 20px;">
                <b>QUINTA POLITICA:</b>
                <p style="margin-top: 5px;">Cuando la Clinica Vesalio recabe datos
                    personales se informara al Titular, de forma libre,
                    previa, expresa, inequivoca e informada, sobre la
                    finalidad para los cuales se esta recabando dicha
                    informacion, asi como quienes seran los
                    destinatarios de dicha informacion, de ser el caso.</p>
            </div>
            <div style="margin-top: 20px;">
                <b>SEXTA POLITICA:</b>
                <p style="margin-top: 5px;">Esta politica le asegura al Titular de datos
                    personales el ejercicio de los derechos de
                    informacion, acceso, rectificacion, cancelacion y
                    oposicion, en los terminos establecidos en la Ley.
                    En cualquier momento, el Titular tendra el
                    derecho a solicitar a la Clinica Vesalio, el ejercicio
                    de los Derechos ARCO, que le confiere la Ley, asi
                    como la revocacion de su consentimiento segun
                    lo previsto en la Ley.</p>
            </div>
            <div style="margin-top: 20px;">
                <b>SEPTIMA POLITICA:</b>
                <p style="margin-top: 5px;">Al brindar sus datos personales a la Clinica Vesalio,
                    el usuario declara tener al menos catorce anos de
                    edad o ser tutor de un menor de edad para otorgar
                    el consentimiento de forma valida de acuerdo a la
                    Ley. La Clinica Vesalio no llevara a cabo
                    voluntariamente el tratamiento de Datos
                    Personales relativos a menores de edad, salvo que
                    Se cuente con el debido consentimiento de acuerdo
                    a la norma aplicable. </p>
            </div>
            <div style="margin-top: 20px;">
                <b>OCTAVA POLITICA: </b>
                <p style="margin-top: 5px;">Clinica Vesalio se reserva expresamente el
                    derecho a modificar, actualizar o completar en
                    cualquier momento la presente Politica de
                    Privacidad. Cualquier modificacion o actualizacion
                    producida en la presente Politica sera
                    inmediatamente comunicada por nuestros medios
                    autorizados.</p>
            </div>
    
    
        </div>
        <div>
            <h2 style="text-align: center; margin-top: 20px;">CONSENTIMIENTO DE TRATAMIENTO DE DATOS PERSONALES</h2>
            <div>
                Declaro haber recibido toda la informacion necesaria y haber tomado conocimiento de la
                POLITICA DE PRIVACIDAD de VESALIO S.A. y otorgo mi consentimiento libre,
                previo, expreso, inequivoco e informado para que mis datos personales obtenidos a
                traves de la informacion proporcionada en virtud de la relacion como PACIENTE sean
                incorporados a los Bancos de Datos de HISTORIAS CLiNICAS, PACIENTES y
                PROSPECCIoN COMERCIAL, los cuales se encuentran debidamente registrados ante
                la Direccion Nacional de Proteccion de Datos Personales con codigos RNPDP-PJP N
                3922, 15398 y 14844 respectivamente; los mismos que cuentan con estrictas medidas
                de seguridad a fin de garantizar la proteccion de su informacion, tanto en los servidores
                propios o de terceros domiciliados en el Peru o en el extranjero (flujo transfronterizo),
                cumpliendo estrictamente con lo establecido en la Ley N 29733 y su Reglamento.
                Asimismo, otorgo mi consentimiento libre, previo, expreso, inequivoco e informado
                para que VESALIO S.A, transfiera mis datos personales a Establecimientos de Salud,
                Empresas Tercerizadas que prestan Servicios de Apoyo al Diagnostico como
                Laboratorios Vesalio SRL, Centro de Diagnostico Ecografias Perez Fernandez SAC, TyM
                Patologo SAC, Tomoclinic SAC, Radiologica SRL, Oncoplan Plus SAC, Arinat SAC,
                Nuevas Alternativas Medicas SAC, Cardiovascular Healthcare SAC, Cardionovo SAC,
                Vasculaine EIRL, ambulancia como Seguricel SAC y en caso de contar con un Seguro
                Medico tambien se transfieran a Entidades Aseguradoras y Entidades Prestadoras de
                Salud (EPS) con las que contrate, de acuerdo al marco normativo establecido para cada
                caso y en los terminos y condiciones de seguridad y proteccion previstos en la Ley N
                29733 y su Reglamento.
                Este consentimiento se extiende durante la totalidad del tiempo que exista un vinculo
                entre VESALIO S.A. y el PACIENTE de acuerdo a la normatividad vigente aplicable para
                el Sector Salud.
                De acuerdo a lo dispuesto en la Ley N 29733 y su Reglamento, EL PACIENTE tiene
                derecho de acceso, rectificacion, cancelacion y oposicion de sus datos personales
                que obran en poder de VESALIO S.A, dicho derecho podra ser ejercido dirigiendose al
                area de Atencion al Cliente ubicada en Calle Joseph Thompson N 140 Urb. Santo
                Tomas, distrito de San Borja.
    
            </div>
        </div>
    
        <div>
            <h2 style="text-align: center; margin-top: 20px;">TERMINOS Y CONDICIONES DE RESERVA DE CITAS WEB</h2>
            <div>
                Agradecemos su preferencia, y cumpliendo con nuestras politicas de transparencia en la
                informacion, enviamos los siguientes terminos y condiciones correspondientes al proceso
                de uso del portal de citas web para la reserva de cita medica; por lo que solicitamos leer
                detenidamente al momento de su registro por primera vez.
            </div>
            <div style="margin-top: 20px;">
                <b>ACCEDER O UTILIZAR PORTAL DE CITAS WEB</b>
                <p style="margin-top: 5px;">Al utilizar el portal de citas Web de Clinica Vesalio usted declara y garantiza
                    que tiene el
                    poder legal y la autoridad para aceptar y estar sujeto a los Terminos y Condiciones
                    establecidos; segun la informacion que ha sido proporcionada como consecuencia del
                    uso del portal de citas Web, por lo que usted declara que dicha informacion es verdadera
                    y cierta.
                    Asimismo, se hace mencion que en caso se consigne informacion falsa, enganosa o
                    incorrecta, usted estara sujeto a responsabilidades tanto civiles como penales que ellas
                    pudieran conllevar.</p>
            </div>
            <div style="margin-top: 20px;">
                <b>FINALIDAD </b>
                <p style="margin-top: 5px;">La Clinica Vesalio pone a disposicion de nuestros pacientes, usuarios y al
                    publico en
                    general el sistema de reservas de citas Web, el cual les permitira programar la fecha,
                    hora, especialidad y medico en la que podran agendar su cita para las atenciones medicas
                    en las instalaciones de Clinica Vesalio, ubicado en Calle Joseph Thompson N 140,
                    distrito de San Borja.
                </p>
            </div>
            <div style="margin-top: 20px;">
                <b>TU CUENTA</b>
                <p style="margin-top: 5px;">
                    Para usar el portal de citas Web es necesario registrarse con los siguientes datos:
                    nombres completos, DNI y/o Carne de Extranjeria, numero de celular, correo electronico,
                    y posterior a ello debera crear una contrasena, la misma que debera mantener la
                    confidencialidad absoluta, dado que usted es responsable de la informacion personal y
                    actividad que se desarrolle en su cuenta o a traves de ella.
                    La Clinica Vesalio se reserva el derecho a denegar el acceso al servicio de portal de citas
                    web, cancelar cualquier cuenta y/o eliminarla, en caso de que el usuario incumpliera con
                    los presentes terminos y condiciones, asi como la legislacion que le sea aplicable.
                </p>
            </div>
            <div style="margin-top: 20px;">
                <b>DE LA RESERVA CITA WEB</b>
                <p style="margin-top: 5px;">
                    El proceso de generacion de citas Web se podra realizar desde cualquier dispositivo
                    electronico con conexion a internet. La Clinica no se hace responsable de los problemas
    
                    Pagina 4 de 4
                    de conectividad que limiten, restrinjan o impidan la prestacion del servicio. Toda reserva
                    de cita sera confirmada por correo electronico o numero de celular registrado.
                </p>
            </div>
            <div style="margin-top: 20px;">
                <b>DEL PAGO</b>
                <p style="margin-top: 5px;">
                    El pago de las consultas medicas, se realizara de la siguiente manera:
                    <li style="margin-left: 20px;">Pago en las instalaciones de la Clinica Vesalio: Al momento de reservar
                        su cita
                        en el Portal de Citas Web, usted solo podra pagar su cita en los modulos de admision
                        ambulatorio.</li>
                </p>
            </div>
        </div>
        <div style="margin-top: 20px;">
            <b>DE LA REPROGRAMACIoN DE CITAS</b>
            <p style="margin-top: 5px;">
                El paciente podra reprogramar su cita, anulando su cita programada y en el caso de
                inasistencia o tardanza, la cita se dara por anulada.
                Ante cualquier duda llamar a la Central telefonica: N 618 9999.
            </p>
        </div>
        <div style="margin-top: 20px;">
            <b>DE LA ASISTENCIA AL DIA DE LA CITA</b>
            <p style="margin-top: 5px;">
                El dia de su cita, usted debera llegar 20 minutos antes de la hora programada con el fin
                de cumplir con el tramite administrativo (la presentacion del DNI y/o Carne Extranjeria
                es obligatorio) y el respectivo pago; de lo contrario perdera su cita y tendra que
                reprogramar para una fecha posterior.
                En caso de no asistir a su cita medica programada, esta se dara por anulada.
                Se recomienda con el fin de evitar aglomeraciones, asistir a las citas programadas solo
                o con un acompanante de ser necesario.
                En caso el paciente sea menor de edad debe asistir con un acompanante.
            </p>
        </div>
        <div style="margin-top: 20px;">
            <b>POLiTICA DE PROTECCIoN DE DATOS PERSONALES</b>
            <p style="margin-top: 5px;">
                
                Sabemos lo valioso que es para el Usuario conocer el uso que hacemos de su informacion 
                personal y el modo en que la compartimos. En consecuencia, la politica de privacidad de 
                la Clinica Vesalio, explican el tratamiento de los datos personales y la proteccion de la 
                privacidad al usar el Portal de Citas Web. Si usas nuestros servicios, aceptas que la 
                clinica use dichos datos de conformidad con sus politicas de privacidad, las mismas que 
                se encuentran publicadas en la pagina Web.
            </p>
        </div>

        
            <div style="display: ${valor.nombres.length > 4 ? 'flex' : 'none'}">
                <b style:"font-size: 18px">${valor.nombres}</b> <b style:"font-size: 18px">${valor.apellidos}</b> 
            </div>

            <div style="margin-left: 0px">
                ${valor.tipo_documento}: <b>${valor.documento}</b>
            </div>

            <div style="margin-left: 0px">
            Fecha de aceptacion: <b>${valor.fecha} ${valor.dates}</b>
            </div>

       
        

    </body>
    
    </html>`;

    let encodedStringBtoA = btoa(decodedStringBtoA);

    return (
        <>
            <Grid alignItems="center" justifyContent={"center"} container spacing={1} sx={{ my: 1, pb: 3 }} >
                <Grid item lg="12" md="12">
                    <Box style={{ marginTop: "20px", display: "flex", justifyContent: "center", justifyItems: "center", alignContent: "center", alignItems: "center", zIndex: "1", top: "1px", width: "100vh" }}>
                        {/* <iframe style={{ height: "100vh", width: "100vh" }} id="pdf-preview" name="pdf-frame" title="Vista previa de PDF" src="">.
                                        </iframe> */}
                        <iframe style={{ height: "100vh", width: "100vh", transform: "scale(0.8)", marginTop: "-70px" }} title="Vista previa de PDF" src={`data:text/html;base64,${encodedStringBtoA}`}>.</iframe>
                    </Box>
                </Grid>


            </Grid>

        </>
    )
}
